import * as THREE from 'three';
import { TableMesh } from './vendor/tablemesh.js';
import { registerFeltMaterial } from './theme.js';

/**
 * テーブル（クロススラブ）を構築。tailuge/billiards の TableMesh を流用。
 * クロスマテリアルは theme へ登録し、設定UIからラシャ色を変更できるようにする。
 * 座標規約: 球中心 z=0、クロスはその下。
 */
export const buildTable = (scene: THREE.Scene): void => {
  const tableMesh = new TableMesh();
  const group = tableMesh.generateTable(true);
  scene.add(group);
  registerFeltMaterial(tableMesh.cloth, 'bed');
};
